import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getNewsStory } from "../../actions/ApiCalls";
import { IMAGE_URL } from "../../path";
import '../Story.css';

interface NewsStoryProps {
    slug: string;
}

function NewsStory({ slug }: NewsStoryProps) {

    const [article, setArticle] = useState<any>(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const navigate = useNavigate();

    const globalStyles = `
        a {
            color: black !important;
            text-decoration: underline;
        }
    `;

    const linkStyle: React.CSSProperties = {
        color: 'black',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        cursor: 'pointer',
    };

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (slug) {
            getNewsStory(slug)
                .then(response => {
                    document.title = "Vinimark | " + response.data?.title;
                    setArticle(response.data);
                })
                .catch(error => console.error("Failed to fetch news story:", error));
        }
    }, [slug]);


    const bodyImagesWithPortrait = article
        ? Object.keys(article)
            .filter(key => key.startsWith("image_path_body_") && article[key])
            .sort((a, b) => {
                const aNum = parseInt(a.split('_').pop() || '0');
                const bNum = parseInt(b.split('_').pop() || '0');
                return aNum - bNum;
            })
            .map(key => {
                const index = key.split('_').pop();
                const portraitKey = `image_${index}_portrait`;
                return {
                    path: article[key],
                    isPortrait: article[portraitKey] === 1
                };
            })
        : [];

    const chunkArray = (arr: any[], sizes: number[]) => {
        const chunks = [];
        let index = 0;
        for (let size of sizes) {
            if (index >= arr.length) break;
            chunks.push(arr.slice(index, index + size));
            index += size;
        }
        if (index < arr.length) chunks.push(arr.slice(index));
        return chunks;
    };

    const layoutSizes = windowWidth > 835 ? [4, 2, 1] : [2, 2, 2, 1];
    const imageChunks = chunkArray(bodyImagesWithPortrait, layoutSizes);

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                width: '100%',
            }}
        >
            <style>{globalStyles}</style>
            <Header />

            <div style={{ display: 'flex', flexDirection: windowWidth > 835 ? 'row' : 'column', marginTop: '140px' }}>
                <div style={{ flex: 1 }} />
                <div style={{ flex: 1, textAlign: 'left' }}>
                    <p style={{ fontWeight: 400, marginLeft: '26px' }}>
                        <a style={linkStyle} onClick={() => navigate('/news')}>
                            BACK to stories
                        </a>
                    </p>
                </div>
            </div>

            <div
                style={{
                    marginTop: '100px',
                    display: 'flex',
                    flexDirection: windowWidth > 835 ? 'row' : 'column',
                    alignItems: 'flex-start'
                }}
            >
                <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", flexDirection: 'column' , paddingLeft: windowWidth > 575 ? '41px' : '0px', paddingRight: windowWidth > 575 ? '13px' : '0px'}}>
                        <div>
                            {article?.video_iframe ? (
                                <div>
                                    {window.innerWidth > 575 ? <iframe
                                        src={article.video_iframe}
                                        style={{
                                            width: '100%',
                                            aspectRatio: '16 / 9',
                                            display: 'flex',
                                            alignContent: 'flex-start',
                                            border: 'none',

                                        }}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                        title={article?.title || 'video'}
                                    /> :
                                        <iframe
                                            src={article.video_iframe}
                                            style={{
                                                aspectRatio: '16 / 9',
                                                display: 'flex',
                                                alignContent: 'flex-start',
                                                border: 'none',
                                                width: '100vw'
                                            }}
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                            title={article?.title || 'video'}
                                        />

                                    }
                                </div>
                            ) : (
                                <img
                                    style={{ width: '100%', display: 'flex', alignContent: 'flex-start' }}
                                    src={IMAGE_URL + article?.image_path}
                                    alt={article?.title}
                                />
                            )}
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: '10px',
                                marginBottom: '10px',
                                textAlign: windowWidth > 575 ? 'right' : 'left',
                                marginLeft: '26px',

                            }}
                        >
                            <div
                                className="content-2-style"
                                dangerouslySetInnerHTML={{
                                    __html: (() => {
                                        const content2 = article?.content_2 || '';
                                        return content2.replace(/<p>/g, '<p style="font-weight: 300">');
                                    })()
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ flex: 1, textAlign: 'left' }}>
                    <div style={{ width: windowWidth > 575 ? '65%' : '90%', marginLeft: '26px' }}>
                        <p style={{ fontWeight: 600, marginTop: 0 , textTransform: 'uppercase'}}>{article?.title}</p>
                        <p className="date-class">{article?.year_posted}</p>

                        <div
                            dangerouslySetInnerHTML={{
                                __html: (() => {
                                    const content = article?.content || '';
                                    // Remove all margin and padding from <p> tags
                                    return content.replace(
                                        /<p>/g,
                                        '<p style="margin:0 !important; padding:0 !important; font-weight:400">'
                                    );
                                })()
                            }}
                        />
                    </div>
                </div>
            </div>

            <div style={{ width: '100%', padding: '0 26px', boxSizing: 'border-box' }}>
                {imageChunks.map((chunk, idx) => (
                    <div
                        key={idx}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '24px',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            marginTop: idx === 0 ? '30px' : '24px',
                        }}
                    >
                        {chunk.map((imageData: any, imgIdx: number) => {
                            const isOnlyHorizontalInRow = chunk.length === 1 && !imageData.isPortrait;

                            return (
                                <img
                                    key={imgIdx}
                                    src={IMAGE_URL + imageData.path}
                                    alt={`body-img-${imgIdx}`}
                                    style={{
                                        width: isOnlyHorizontalInRow
                                            ? (windowWidth < 575 ? '100%' : '99%')
                                            : windowWidth < 575
                                                ? (imageData.isPortrait ? '46.7%' : '100%')
                                                : (imageData.isPortrait ? '23.5%' : '48.5%'),
                                        aspectRatio: imageData.isPortrait ? '4/5' : '16/9',
                                        maxWidth: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>


            <Footer />
        </div>
    );
}

export default NewsStory;
